import { FaChartLine } from "react-icons/fa";
import { useAuth } from "../../../context/AuthProvider";
import { useUserConfig } from "../../../context/UserConfigProvider";
import BankedTipsWidget from "../dashboard/widgets/BankedTipsWidget";
import CumCounterUpdate from "../dashboard/widgets/CumCounterUpdate";
import DenyStatusUpdate from "../dashboard/widgets/DenyStatusUpdate";

const BroadcasterDashboard = () => {
  const { permissions } = useUserConfig();
  const { user } = useAuth();

  // Check if user is a broadcaster or mod
  if (!user?.isBroadcaster && !permissions.isMod) {
    return (
      <div className="h-full flex items-center justify-center bg-base-200">
        <div className="text-center">
          <div className="text-error text-2xl font-bold mb-4">
            Access Denied
          </div>
          <div className="text-gray-400">
            Only broadcasters and mods can view the broadcaster dashboard
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className=" h-full flex flex-col p-4 gap-4">
      <div className="card  flex flex-col">
        <div className="card-body">
          <h2 className="card-title flex items-center gap-2">
            <FaChartLine size={24} className="text-primary" />
            Broadcaster Dashboard
          </h2>

          <div className="divider m-0" />

          {/* Deny Status Widget */}
          <div className="flex flex-row flex-wrap justify-center gap-4">
            <DenyStatusUpdate />
            <CumCounterUpdate />
          </div>

          {/* What's owed between shows */}
          <div className="flex justify-center mt-4">
            <BankedTipsWidget />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadcasterDashboard;
